import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
export default function useCommentList() {
    const isGroupFormSidebarActive = ref(false);
    const isCommentFormSidebarActive = ref(false);
    const groups = ref([]);
    const toast = useToast();
    const groupData = ref({});
    const commentData = ref({});
    const catFilter = ref(null);
    const getLocalSite = JSON.parse(localStorage.getItem('site'))
    const updateDisplay = (events)=>{
      // console.log(events)
    }

    const updateGroup = (group)=>{
        isGroupFormSidebarActive.value = true;
        groupData.value = group;
    }
    const addGroup = ()=>{
        isGroupFormSidebarActive.value = true;
        groupData.value = {}
    }
    const updateNav = (nav)=>{
        isCommentFormSidebarActive.value = true;
        commentData.value = nav;
    }
    const addNav = (group_id)=>{
        isCommentFormSidebarActive.value = true;
        commentData.value = {
            group_id:group_id,
            types:'comment',
            is_active:1,
            name:{},
            comment:{},
            rating:5,
            lang:'',
            url:''
        }
    }

    watch([catFilter], () => {
      updateDisaply()
    })

    const updateDisaply = ()=>{
      store
        .dispatch('app-comment/updateDisplay', {id:catFilter.value})
        .then(response => {
          if(response.status == 200){
           /* toast({
            component: ToastificationContent,
            props: {
                title: "Changed the display platform successfully.",
                icon: 'AlertSuccessIcon',
                variant: 'success',
            },
            })*/
          }
          else{
            toast({
            component: ToastificationContent,
            props: {
                title: "Error change platform to display'",
                icon: 'AlertTriangleIcon',
                variant: 'danger',
            },
            })
          }
          

        })
        .catch((error) => {
            // console.log('error',error);
            
        })
    }
    const refetchData = ()=>{
        store
        .dispatch('app-comment/fetchData', {
          sites_id: getLocalSite.id
        })
        .then(response => {
            
            const  data  = response.data.data;
            groups.value =data;
            const catFilter_item = data.filter(item => item.is_display == 1);

            if(catFilter_item.length>0){
              catFilter.value = catFilter_item[0].id;
            }
           

            //const total = response.data.total?response.data.total:cats.length;
            //callback(cats)
    
        })
        .catch((error) => {
            toast({
            component: ToastificationContent,
            props: {
                title: "Error fetching Group' list",
                icon: 'AlertTriangleIcon',
                variant: 'danger',
            },
            })
        })
            
    }
    refetchData();
    
      const undateOrdering = (key)=>{
        let navs = groups.value[key].comments;
         
        store.dispatch('app-comment/updateOrdering',navs)
        
        
    }

    const deleteData = (id) => {
        //fetchDeleteProperty
        store.dispatch('app-comment/deleteData',id).then(response=>{
          toast({
            component: ToastificationContent,
            props: {
              title: "Delete Success",
              icon: 'AlertTriangleIcon',
              variant: 'success',
            },
          })
          refetchData();
        }).catch(()=>{
          toast({
            component: ToastificationContent,
            props: {
              title: "Error Delete Comment",
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
    
        })
        //console.log('id', id);
        
      }
      const deleteGroupData = (id) => {
        //fetchDeleteProperty
        store.dispatch('app-comment/deleteGroupData',id).then(response=>{
          toast({
            component: ToastificationContent,
            props: {
              title: "Delete Success",
              icon: 'AlertTriangleIcon',
              variant: 'success',
            },
          })
          refetchData();
        }).catch(()=>{
          toast({
            component: ToastificationContent,
            props: {
              title: "Error Delete Group Comment",
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
    
        })
        //console.log('id', id);
        
      }
      return {
        catFilter,
        groups,
        groupData,
        isGroupFormSidebarActive,
        isCommentFormSidebarActive,
        updateDisplay,
        undateOrdering,
        updateGroup,
        addGroup,
        refetchData,
        addNav,
        updateNav,
        commentData,
        deleteData,
        deleteGroupData
      }
    
}